<template>
    <div class="profile">
        <top-nav></top-nav>
        <theme-sidebar :sortMode.sync="themeSortMode" :sortDirection.sync="themeSortDirecton">
            <div :class="themeWrapperClass">
                    <div class="col-1" v-for="n in themeCols" :key='n'>
                        <div class="theme" @click="$router.push({path:'/'+theme.uuid})" v-for="theme in getThemeCol(n)" :key="theme.uuid">
                            <div class="theme__name">{{theme.name}}</div>
                            <div v-for="color in theme.colors.colors" :key="color" :style="{backgroundColor:color,color:$store.state.Color.contrastTextColor(color,'hex')}" class="theme__color">{{color}}</div>
                            <div class="theme__subtitle">
                                <span v-if="themeSortMode=='last_modified'">{{theme.last_modified | moment("from","now")}}</span>
                                <span v-else-if="themeSortMode=='date_created'">{{theme.date_created | moment("from","now")}}</span>
                                <span v-else-if="themeSortMode=='size'">{{theme.colors.colors.length}} color(s)</span>
                            </div>
                        </div>
                    </div>
            </div>
        </theme-sidebar>
    </div>
</template>
<script type="text/javascript">
import topNav from "@/components/topNav.vue";
import themeSideBar from "@/components/themeSidebar.vue";
    export default{
        data(){
            return {
                themeData:[],
                themeCols:4,
                themeWrapperClass:'grid-4',
                themeSortMode:'last_modified',
                themeSortDirecton:'forward',
            };
        },
        methods:{
            getThemes(){    
                this.$store.state.HTTP.get("account/theme/").then((response)=>{
                    response.data.data.forEach((val)=>{
                        let theme = val[0];
                        this.themeData.push({
                            "uuid":theme[0],
                            "name":theme[1],
                            "popularity":theme[2],
                            "date_created":theme[3],
                            "colors":JSON.parse(theme[4]),
                            "last_modified":theme[5],
                        })
                    })
                    this.sortThemeData();
                }).catch((error)=>{
                    if(error.response.status==401){
                        this.$store.dispatch('refreshTokens',this.getThemes);
                    }
                });
            },
            screenResize(){
                let minCols = 1;
                if(window.innerWidth>1200){
                    this.themeCols=minCols+3;
                    this.themeWrapperClass = 'grid-'+(minCols+3)
                }else if(window.innerWidth>992){
                    this.themeCols=minCols+2;
                    this.themeWrapperClass = 'grid-'+(minCols+2)
                }else if(window.innerWidth>769){
                    this.themeCols=minCols+1;
                    this.themeWrapperClass = 'grid-'+(minCols+1)
                }else{
                    this.themeCols=minCols;
                    this.themeWrapperClass = 'grid-'+(minCols)
                }
            },
            sortThemeData(){
                let sortFunction;
                if(this.themeSortDirecton=="forward"){
                    switch(this.themeSortMode){
                        case "date_created":
                            sortFunction = (a,b)=>((new Date(b.date_created)).getTime() - (new Date(a.date_created)).getTime());
                            break;
                        case "alpha":
                            sortFunction = (a,b)=>(b.name < a.name) ? 1 : -1;
                            break;
                        case "alpha_rev":
                            sortFunction = (a,b)=>(b.name > a.name) ? 1 : -1;
                            break;
                        case "size":
                            sortFunction = (a,b)=>(b.colors.colors.length > a.colors.colors.length) ? 1 : -1;
                            break;
                        case "last_modified":
                        // falls through
                        default:
                            sortFunction = (a,b)=>((new Date(b.last_modified)).getTime() - (new Date(a.last_modified)).getTime());
                            break;
                    }
                }else{
                    switch(this.themeSortMode){
                        case "date_created":
                            sortFunction = (a,b)=>((new Date(a.date_created)).getTime()- (new Date(b.date_created)).getTime());
                            break;
                        case "alpha":
                            sortFunction = (a,b)=>(b.name > a.name) ? 1 : -1;
                            break;
                        case "alpha_rev":
                            sortFunction = (a,b)=>(b.name < a.name) ? 1 : -1;
                            break;
                        case "size":
                            sortFunction = (a,b)=>(b.colors.colors.length < a.colors.colors.length) ? 1 : -1;
                            break;
                        case "last_modified":
                        // falls through
                        default:
                            sortFunction = (a,b)=>((new Date(a.last_modified)).getTime() - (new Date(b.last_modified)).getTime());
                            break;
                    }
                }
                this.themeData.sort(sortFunction);
            },
            getThemeCol(colNum){
                let col = [];
                for(let i=colNum-1;i<this.themeData.length;i+=this.themeCols){
                    col.push(this.themeData[i]);
                }
                return col;
            }
        },
        components:{
            "top-nav":topNav,
            "theme-sidebar":themeSideBar,
        },
        computed:{
            authValid(){
                return this.$store.state.authValid;
            },
        },
        mounted(){
            this.getThemes();
            window.addEventListener("resize",this.screenResize);
            this.screenResize();
        },
        watch:{
            authValid(newVal,oldVal){
                if(this.startingRequest){
                    this.startingRequest = false;
                }else{
                    if(newVal && !oldVal){ 
                        this.getThemes();
                    }
                }
            },
            themeSortMode(){
                this.sortThemeData();
            },
            themeSortDirecton(){
                this.sortThemeData();
            }
        }
    }
</script>
<style type="text/css">
    .theme{
        width: 90%;
        margin: 5%;
        padding: 5%;
        box-sizing: border-box;
        background-color: #FFF;
        cursor: pointer;
        border-radius: 5px;
        box-shadow: 0 5px 15px rgba(0,0,0,0.5);
    }
    .theme .theme__name{
        text-align: center;
        color: #333;
        margin-bottom: 5%;
    }
    .theme .theme__color{
        padding: 5% 0;
        text-align: center;
        border:solid 1px rgba(0,0,0,0.1);
    }
    .theme .theme__subtitle{
        margin-top: 5%;
        font-style: italic;
        font-style: 0.8em;
    }
</style>